<template>
  <div>
    <el-form
      label-position="right"
      :model="ruleForm"
      :rules="rules"
      :disabled="currentData.disabled"
      ref="ruleForm"
      label-width="130px"
      class="demo-ruleForm"
      @submit.native.prevent
    >
      <el-form-item
        label="广告系列名称："
        prop="name"
      >
        <el-input
          v-model="ruleForm.name"
          @input="emitMsg"
          clearable
        ></el-input></el-form-item
      ><el-form-item
        label="状态："
        prop="status"
      >
        <el-switch
          v-model="ruleForm.status"
          @change="emitMsg"
          active-text="开启"
          inactive-text="暂停"
          active-value="ENABLED"
          inactive-value="PAUSED"
        ></el-switch>
      </el-form-item>
      <el-form-item label="系列跟踪参数：">
        <CampaignTraceConfig
          v-model="ruleForm.campaignTraceConfig"
          @input="emitMsg"
        />
      </el-form-item>
    </el-form>
    <!-- <campaignBudget
      ref="campaignBudget"
      :disabled="currentData.disabled"
      :currentAccount="createAdAccount"
      :enumConstants="enumConstants"
      v-model="ruleForm"
      @change="onChange"
    /> -->
    <BudgetBidding
      ref="campaignBudget"
      :value="{
        bidAmount: ruleForm.bidAmount,
        bidStrategy: ruleForm.bidStrategy,
        budgetAmount: ruleForm.budgetAmount,
        budgetType: ruleForm.budgetType,
        startDate: ruleForm.startDate,
      }"
      @input="handleBudgetChange"
      :disabled="currentData.disabled"
      :enumConstants="enumConstants"
      :createAdAccount="createAdAccount"
    />
    <!-- <el-form
      ref="form"
      :model="ruleForm"
      label-width="80px"
      :disabled="currentData.disabled"
    > -->
    <!-- 广告系列 -->
    <AdCampaign
      ref="campaignComponent"
      v-model="ruleForm.campaignCriterion"
      @input="emitMsg"
      :disabled="currentData.disabled"
      :enumConstants="enumConstants"
      :createAdAccount="createAdAccount"
    />
    <!-- </el-form> -->
  </div>
</template>

<script>
import CampaignTraceConfig from '@/views/google/create/components/campaignInfo/components/campaignTraceConfig.vue';
import campaignBudget from '@/views/google/create/components/campaignInfo/components/campaignBudget.vue';
import BudgetBidding from '../../createSearchAds/components/BudgetBidding.vue';
import AdCampaign from '../../createSearchAds/components/AdCampaign.vue';
export default {
  // 组件名称
  name: 'campaign',
  // 组件参数 接收来自父组件的数据
  props: {
    currentData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    createAdAccount: {
      type: Object,
      default: () => {
        return {};
      },
    },
    enumConstants: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  // 局部注册的组件
  components: {
    CampaignTraceConfig,
    campaignBudget,
    BudgetBidding,
    AdCampaign,
  },
  // 组件状态值
  data() {
    return {
      ruleForm: {},
      //   ruleForm: {
      //     name: '',
      //     status: 'ACTIVE',
      //   },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      pickerOptions1: {
        disabledDate: this.disabledDate,
      },
      rules: {
        name: [
          { required: true, message: '请输入广告系列名称', trigger: ['blur', 'change'] },
          { min: 1, max: 375, message: '长度在 1 到 375 个字符', trigger: ['blur', 'change'] },
        ],

        'campaignTraceConfig.utmSourceConfig': [
          {
            validator: (rule, value, callback) => {
              if (this.ruleForm.campaignTraceConfig && this.ruleForm.campaignTraceConfig.enable && !value) {
                callback(new Error('请选择推广渠道'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
      },
    };
  },
  watch: {
    currentData: {
      handler() {
        console.log(this.currentData, ' this.currentData');
        this.ruleForm = this.currentData;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    /**对外抛出验证 */
    async checkForm() {
      try {
        console.log(this.$refs.ruleForm.validate(), this.$refs.campaignBudget.validate());
        const [mainFormValid, budgetFormValid, campaignComponent] = await Promise.all([
          this.$refs.ruleForm.validate(),
          this.$refs.campaignBudget.validate(),
          this.$refs.campaignComponent.validate(),
        ]);
        console.log(mainFormValid, budgetFormValid, campaignComponent);
        return mainFormValid && budgetFormValid && campaignComponent;
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    handleBudgetChange(v) {
      console.log(v, 'vvvv');
      this.ruleForm = Object.assign(this.ruleForm, v);
      this.emitMsg();
    },
    onChange(v) {
      this.ruleForm = v;
      this.emitMsg();
    },
    emitMsg() {
      console.log(this.ruleForm, 'vvvvvvvvvvvvvv');
      this.$emit('change', JSON.parse(JSON.stringify(this.ruleForm)));
    },
  },
};
</script>
<style lang="scss" scoped></style>
